import { useQuery } from '@tanstack/react-query';

import { getDiscoveryService } from '../services/discoveryService';
import { useManifest } from './useManifest';

export function usePlaceGroups(
  clientName: string,
  siteId: number | undefined,
  kioskId: string | undefined,
) {
  const discoveryService = getDiscoveryService()!;

  const { data } = useManifest(clientName);

  const etag = discoveryService?.getPlaceGroupsEtag();
  return useQuery({
    staleTime: Infinity,
    queryKey: ['placesgroups.json', siteId, kioskId, clientName, etag],
    enabled: !!data,
    queryFn: async () => {
      const resp = await discoveryService.getPlaceGroups();

      const withSiteId = resp.data.find(
        (kioskData) =>
          kioskData.directory_tiles.find((pg) => pg.site_id === siteId) !==
          undefined,
      );

      const id = kioskId ?? withSiteId?.kiosk_id;
      const kioskData = resp.data.find(
        (placeGroup) => placeGroup.kiosk_id === id,
      );
      return kioskData?.directory_tiles.filter(
        (placeGroup) => placeGroup.site_id === siteId,
      );
    },
  });
}
